import { createContext } from "react";

const ShopingContext = createContext();

export default ShopingContext;
